import { AtividadeColetivaGrupoDetalhesQuery } from 'graphql/types.generated'

export enum AtividadeColetivaGrupoCabecalho {
  MEUS_GRUPOS = 'MEUS_GRUPOS',
  OUTROS_GRUPOS = 'OUTROS_GRUPOS',
}

export enum AtividadeColetivaGrupoSemResultados {
  SEM_RESULTADOS_ENCONTRADOS = 'SEM_RESULTADOS_ENCONTRADOS',
}

type AtividadeColetivaGrupoDetalhes = AtividadeColetivaGrupoDetalhesQuery['grupoParticipanteAtividadeColetiva']

export type CidadaoGrupoItemModel = AtividadeColetivaGrupoDetalhes['cidadaosParticipantes'][0]
export type LotacaoGrupoItemModel = AtividadeColetivaGrupoDetalhes['lotacoesEnvolvidas'][0]

export type AtividadeColetivaGrupoItemModel = {
  id: ID
  nome: string
  equipesEnvolvidas: string
  unidadeDeSaude: string
}

export type AtividadeColetivaGrupoComIntegrantesModel = AtividadeColetivaGrupoItemModel & {
  cidadaos: ReadonlyArray<CidadaoGrupoItemModel>
  lotacoes: ReadonlyArray<LotacaoGrupoItemModel>
}

export type AtividadeColetivaGrupoSelectItemModel =
  | AtividadeColetivaGrupoCabecalho
  | AtividadeColetivaGrupoSemResultados
  | AtividadeColetivaGrupoItemModel
